
<div
    class  = "unit-details"
    :class = "unit.lastInGroup ? 'unit-header-divider ' : ''"
>
    <!-- Action buttons -->
    <p-assign-buttons
        v-if          = "assignOn"
        :plus-active  = "(!unit.orderId || unit.orderId === order.id) && !isAssigned"
        :minus-active = "isAssigned"
        @plus         = "onAssign"
        @minus        = "onDissolve"
    />

    <p-dispatch-buttons
        v-if          = "dispatchOn"
        :plus-active  = "!isDispatched && !!assignment"
        :minus-active = "isDispatched && (isDisponent || isDispatcher || assignment.technicianIdent === user.ident)"
        :user         = "user"
        @plus         = "onDispatch"
        @minus        = "onRelease"
    />
    <!-- Action buttons -->

    <div class="unit-street-no">
        Nr.{{ unit.number }}
    </div>

    <div class="unit-ident">
        <c-tag
            :label           = "contract"
            :active          = "false"
            :width           = "40"
            :background-color = "assignment && assignment.hasErrors ? 'red' : 'primary'"
        />

        <div
            class="unit-elevator-no"
            :class="active ? 'black--text' : 'lightgray'"
        >
            {{ unit.elevatorNo }}
        </div>

        <div class="inspection-status">
            <v-icon
                size="18"
                color="primary"
            >
                {{ status }}
            </v-icon>
        </div>

        <!-- device type conflict of the app (HCIT-943) -->
        <div v-if="unit.deviceTypeConflict" class="inspection-status" :title="$t('disposition.inspection.deviceType.conflict.title')">
            <v-icon size="18" color="error">mdi-alert-octagon-outline</v-icon>
        </div>
    </div>

    <div class="inspection-user">
        {{ assignedUser }}
    </div>

    <v-spacer/>

    <div class="inspection-date primary--text">
        {{ inspectionDate }}
    </div>

    <!-- elevator lgs icon -->
    <c-lgs-button
        v-if  = "unit['deviceLgSmart']"
        class = "unit-lgs-icon"
        :unit = "unit"
    />
    <!-- elevator lgs icon -->

    <!-- elevator type icon -->
    <c-site-icon
        class="unit-type-icon"
        :site="unit"
        @selected="onEdit"
    />
    <!-- elevator type icon -->
</div>
